import { paperGoodsReceiptBusiness } from "api/bussiness/paper-material/paper-goods-receipt";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import { useCallback, useState } from "react";

export const useRollNumber = () => {
  const [branchWithRollNumber, setBranchWithRollNumber] = useState<
    Map<string, string>
  >(new Map());
  const getRollNumberOptions = useCallback(
    async (materialId: string): Promise<OptionItem[]> => {
      const paperGoodsReceiptItems =
        await paperGoodsReceiptBusiness.getReceiptedRollNumbersByPaperMaterialId(
          materialId,
        );
      const paperGoodsReceiptItemsWithRollNumberNotEmpty =
        paperGoodsReceiptItems.filter((x) => x.rollNumber);
      const rollNumberAsOptionItems =
        paperGoodsReceiptItemsWithRollNumberNotEmpty.map(
          (item) =>
            item.rollNumber && {
              label: item.rollNumber,
              value: item.rollNumber,
            },
        );
      setBranchWithRollNumber(
        paperGoodsReceiptItemsWithRollNumberNotEmpty.reduce((map, obj) => {
          if (obj.rollNumber) {
            map.set(obj.rollNumber, obj.brand ?? "");
            return map;
          }
          return map;
        }, new Map<string, string>()),
      );
      return rollNumberAsOptionItems as OptionItem[];
    },
    [],
  );

  const getBrandByRollNumber = useCallback(
    (rollNumber: string): string => {
      return branchWithRollNumber.get(rollNumber) || "";
    },
    [branchWithRollNumber],
  );
  return { getRollNumberOptions, getBrandByRollNumber };
};
